import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, catchError, map } from 'rxjs';
import { MCustomerMenuResponse } from 'src/app/components/sub-header-category/sub-header-category.module';
import { UtilsService } from 'src/app/utils/utils.service';

@Injectable({
  providedIn: 'root'
})
export class WsSubHeaderService {

  constructor(private httpClient: HttpClient) { }

  /**
  * Date:- 09-06-2023
  * Method :- This method is used for Customer Menu List 
  * @returns 
  */
  getCustomerMenuList(): Observable<MCustomerMenuResponse> {
    return this.httpClient.get<MCustomerMenuResponse>(UtilsService.BASE_URL + UtilsService.CUSTOMERMENU)
      .pipe(
        map(response => {
          return response;
        }), catchError(UtilsService.ErrorHandler.handleError('getData'))
      )
  }
}
